import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import TagsShowcase from './TagsShowcase';
import { FILTERKEYS } from './constants';

const TagsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-tags-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((tags, i) => (
                  <li key={`tags-${group.type}-showcase-${i}`}>
                    <TagsShowcase {...tags} />
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

TagsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

TagsList.displayName = 'TagsList';

export default TagsList;


// WEBPACK FOOTER //
// ./src/containers/elements/Tags/TagsList.js